import usePageName from "../../../hocs/usePageName";
import { Container } from "@mui/material";
import EditPickup from "../../admin/ReadyForPickup/EditPickup";

const EditPickupPage = () => {
  usePageName({
    heading: "Edit Pickup/Delivery",
    caption: null,
  });

  return (
    <Container>
      <EditPickup />
    </Container>
  );
};

export default EditPickupPage;
